module.exports = require("material-ui/Paper");


//////////////////
// WEBPACK FOOTER
// external "material-ui/Paper"
// module id = 286
// module chunks = 0